import { render, staticRenderFns } from "./ruleGold.vue?vue&type=template&id=1ad98abd&scoped=true"
import script from "./ruleGold.vue?vue&type=script&lang=js"
export * from "./ruleGold.vue?vue&type=script&lang=js"
import style0 from "./ruleGold.vue?vue&type=style&index=0&id=1ad98abd&prod&lang=css"
import style1 from "./ruleGold.vue?vue&type=style&index=1&id=1ad98abd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad98abd",
  null
  
)

export default component.exports